<template>
  <v-layout row justify-center>
    <v-dialog
      :value="showModal"
      :fullscreen="options.fullscreen"
      @input="cancelModal"
      light
      :max-width="800"
    >
      <component :is="component"/>
    </v-dialog>
    <v-dialog
      :value="showModal && loading"
      persistent
      :transition="false"
      width="140"
    >
      <v-card
        color="white"
        dark
      >
        <v-card-text>
          <Loader class="modal-loader mb-3"/>
          <div class="black--text text-xs-center font-weight-bold">{{ $t('PROCESSING') }}...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import Loader from '../shared/Loader';

  export default {
    name: 'TheModal',
    components: { Loader },
    computed: {
      ...mapState('modal', ['showModal', 'component', 'loading', 'options']),
    },
    methods: {
      ...mapActions('modal', ['cancelModal']),
      buttonPressed(event) {
        if (event.keyCode === 27) {
          this.cancelModal({});
        }
      },
    },
    watch: {
      showModal(show) {
        if (show) {
          window.addEventListener('keydown', this.buttonPressed);
        } else {
          window.removeEventListener('keydown', this.buttonPressed);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .modal-loader {
    margin: 0px;
    display: block;
  }
</style>
